import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesReviewContractComponent} from "./sales-review-contract.component";
import {
  SalesReviewContractV2Component,
  SalesReviewContractV3Component
} from "./versions/sales-review-contract-versions.component";
import {LibraryModule} from "library";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesReviewContractComponent,
    SalesReviewContractV2Component,
    SalesReviewContractV3Component
  ],
  imports: [
    CommonModule,
    LibraryModule,
    PrimengModule,
    ReactiveFormsModule,
    FormsModule,
    GeneralModule
  ],
  exports: [
    SalesReviewContractComponent,
    SalesReviewContractV2Component,
    SalesReviewContractV3Component
  ]
})
export class SalesReviewContractModule { }
